import { useEffect } from "react";
function useAnalyticsModalDatePickerHook(dateRange) {

    const checkError = () => {

        const disabledButtonOrNot = () => {
            const button = document.querySelector('.content .button.validate')
            const inputsErrors = [...document.querySelectorAll('.rdrInvalidDateInput')];
            button.disabled = inputsErrors.length ? true : false
        }
        setTimeout(disabledButtonOrNot, 100)
        
    }
    
    useEffect(() => {
        if(dateRange == null) {

            return null;
        }

        const [inputStart, inputEnd] = [...document.querySelectorAll('.rdrDateInput > input')]
        inputStart.addEventListener('blur', checkError);
        inputEnd.addEventListener('blur', checkError);
        inputStart.classList.add('date_start')
        inputEnd.classList.add('date_end')
        return () => {
            inputStart.removeEventListener('blur', checkError);
            inputEnd.removeEventListener('blur', checkError);
        }
    }, []);

    return { checkError }
}

export default useAnalyticsModalDatePickerHook;